module.exports = __webpack_public_path__ + "img/card_img_10.021e5876.png";